<template>
  <div class="dashboard">
    <v-container style="max-width: 1024px;">
      <!--
      <v-row>
        <v-col v-for="n in 3" :key="n"  cols="12" sm="6" md="4" >
          <Bars :index="n"/>
        </v-col>
      </v-row>
      <v-row>
        <v-col v-for="n in 3" :key="n"  cols="12" sm="6" md="4" >
          <Lines :index="n"/>
        </v-col>
      </v-row>
      -->
      <v-row>
        <v-col cols="12" >
          <Map />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import embed from "vega-embed";
export default {
  components: {
    Bars: () =>
      import(
        /* webpackChunkName: "chart-bars" */ "@/components/charts/Bars.vue"
      ),
    Lines: () =>
      import(
        /* webpackChunkName: "chart-lines" */ "@/components/charts/Lines.vue"
      ),
    Map: () =>
      import(
        /* webpackChunkName: "chart-map" */ "@/components/charts/Map.vue"
      ),
  },

  data() {
    return {};
  },

  computed: {},

  watch: {},

  methods: {},

  mounted() {}
};
</script>

<style scoped>
</style>